/**
 * What the cookie policy tells search engines and link previews — ONE copy, read by today's page
 * (src/pages/Cookie.tsx) and its rebuild in the new design (src/design/pavilion/pages/cookie-policy/), the way
 * src/config/aboutSeo.ts serves both about pages (PV5a, design record §7b lane A).
 *
 * THE SHAPE IS READ BY THE GUEST CHAT'S KNOWLEDGE SOURCE (scripts/generate-guest-knowledge-source.mjs lists this file
 * for "/cookie-policy"): its extractor takes a `title:` / `description:` field whose string sits on the same line, so
 * each stays one line.
 */

/** Where search files the cookie policy, whichever address served it. */
export const COOKIE_CANONICAL_URL = 'https://prest0.ai/cookie-policy';

/** The props both cookie policy pages hand to <SeoHead>. */
export const COOKIE_SEO = {
  title: 'Cookie Policy | prest0',
  tabTitle: 'cookie policy',
  description: 'Understand how prest0 uses cookies and tracking technologies across our enterprise legal AI platform.',
  keywords: 'cookie policy, prest0 cookies, enterprise legal AI cookies, legal platform tracking',
  canonicalUrl: COOKIE_CANONICAL_URL,
  schemaType: 'WebPage',
} as const;
